<template>
    <div style="display: none;">
        <component :is="selectedTheme"/>
    </div>
</template>
<script>
    const BASE_URI = window.base_uri;
    const MODULE_URL = 'modules/cofiscart';
    const ENDPOINTS_FILE = MODULE_URL + '/cofiscartajax.php';

    import {mapState} from 'vuex'

    import Globalmoto from "./Globalmoto/Globalmoto";
    import Store919 from "./Store919/Theme";
    import FourStep from "./FourStep/FourStep";
    import OneStep from "./OneStep/OneStep";
    import Profimodel from './Profimodel/Profimodel.vue';

    export default {
        name: 'Cart',
        components: {
            'globalmoto': Globalmoto,
            'store-919': Store919,
            'four-step': FourStep,
            'one-step': OneStep,
            'profimodel': Profimodel
        },
        computed: {
            ...mapState({
                products: state => state.products,
                carriers: state => state.carriers,
                selectedCarrier: state => state.selectedCarrier,
                translations: state => state.translations,
                allPayments: state => state.allPayments,
                config: state => state.config,
                currentPayment: state => state.currentPayment,
                carriersPaymentsMap: state => state.carriersPaymentsMap,
                voucher: state => state.voucher,
                isLoggedIn: state => state.isLoggedIn,
                user: state => state.user,
            }),
            selectedTheme: function () {
                const themes = {
                    1: 'globalmoto',
                    2: 'store-919',
                    3: 'profimodel',
                    4: 'one-step',
                    5: 'four-step'
                };

                return themes[this.$store.state.config.theme];
            },
        },
        mounted() {
          this.showLoading();
          this.$el.style.display = 'block';
            CofisCartEvent.on('syncState', () => {
                this.syncState()
                .then(() => {
                    if (window.ps && window.ps.cartSummaryScript) {
                        const script = document.createElement('script');
                        script.src = window.ps.cartSummaryScript;
                        document.head.append(script);
                    }
                })
                .then(() => {
                    this.initialLoadingDone();
                    this.loadCarriersAndPayments();
                    this.emitLoadedEvent();
                })
            });
            CofisCartEvent.dispatch('syncState')
        },
        data() {
           return {
               cofisCartLoadedEmitted: false,
           }
        },
        methods: {
            emitLoadedEvent: function () {
                if (this.cofisCartLoadedEmitted === false) {
                    this.cofisCartLoadedEmitted = true;
                    if (typeof prestashop !== 'undefined' && typeof prestashop.emit === 'function') {
                      prestashop.emit('cofisCartLoaded');
                    }
                }
            },
            initialLoadingDone: function () {
                return this.$store.commit('SET_INITIAL_LOADING', false);
            },
            loadCarriersAndPayments: function () {
                return this.$store.dispatch('LOAD_CARRIERS_AND_PAYMENTS');
            },
            formatPrice: function (price) {
                const decimals = Math.pow(10, this.config.currency_decimals);
                return (Math.round(price * decimals) / decimals) + ' ' + this.config.currency_sign
            },
            step3to4transition: function () {
                this.validateUserData()
                .then(() => {
                    if (!this.userHasError) {
                        this.step = 4
                    }
                });
            },
            changeStep: function (step) {
                if (this.step > step.index) {
                    this.step = step.index
                }
            },
            syncState: function () {
                return this.$store.dispatch('LOAD_CUSTOMER_DETAILS')
                  .then(() => {
                      return this.$store.dispatch('SYNC_STATE');
                  })
            },
            applyVoucher: function () {
                fetch(BASE_URI + ENDPOINTS_FILE + '?action=validateVoucher&discount_name=' + this.voucher.code + '&t=' + new Date().getTime(), {credentials: "include"})
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    if (data.state === 'invalid') {
                        this.voucher.state = data.state;
                    } else {
                        this.syncState()
                    }
                })
            },
            removeVoucher: function () {
                const voucher = {...this.voucher};
                this.voucher.state = 'empty';
                this.voucher.code = '';
                fetch(BASE_URI + ENDPOINTS_FILE + '?action=removeVoucher' + '&t=' + new Date().getTime(), {credentials: "include"})
                .then((response) => {
                    if (response.ok === false) {
                        this.voucher = voucher;
                    }
                    this.syncState();
                })
            },
            login: function () {
                const formData = new FormData;
                formData.append('email', this.user.email);
                formData.append('passwd', this.user.password);
                fetch('/?controller=auth&SubmitLogin=true&ajax=true' + '&t=' + new Date().getTime(), {
                    method: 'POST',
                    body: formData,
                    credentials: "include"
                })
                .then(response => response.json())
                .then(data => {
                    if (data.hasError === true) {
                        this.loginFormErrors = data.errors.map(item => decodeURI(item));
                        return;
                    }
                    this.loginFormErrors = [];
                })
            },
            showLoading: function () {
                const body = document.getElementsByTagName('body')[0];
                const coverSpin = document.createElement('div');
                coverSpin.id = 'cart-cover-spin';
                body.appendChild(coverSpin);
            },
            hideLoading: function () {
                document.getElementById('cart-cover-spin').remove();
            },
            finishOrder: function () {
                this.showLoading();
                if (this.$store.getters.hasUserError) {
                    const header = document.querySelector('#header');
                    const erroneousInput = document.querySelector('.is-invalid');
                    const erroneousContainer = erroneousInput.parentNode;

                    window.scrollTo({
                        top: erroneousContainer.getBoundingClientRect().top + window.scrollY - header.offsetHeight,
                        left: erroneousContainer.getBoundingClientRect().left + window.scrollX,
                        behavior: 'smooth',
                    });

                    this.hideLoading();
                    return;
                }

                if (this.$store.getters.containsVirtualProduct === false) {
                    document.querySelectorAll('.carrier-line').forEach(item => {
                        item.classList.remove('has-error')
                    });

                    if (!this.selectedCarrier) {
                        document.querySelectorAll('.carrier-line').forEach(item => {
                            item.classList.add('has-error')
                        });

                        const header = document.querySelector('#header');
                        const carriersElement = document.querySelector('.carriers');

                        window.scrollTo({
                            top: carriersElement.getBoundingClientRect().top + window.scrollY - header.offsetHeight,
                            left: carriersElement.getBoundingClientRect().left + window.scrollX,
                            behavior: 'smooth',
                        });

                        this.hideLoading();
                        return;
                    }
                }

                document.querySelectorAll('.payment-line').forEach(item => {
                    item.classList.remove('has-error')
                });

                if (!this.currentPayment) {
                    document.querySelectorAll('.payment-line').forEach(item => {
                        item.classList.add('has-error')
                    });

                    const header = document.querySelector('#header');
                    const paymentsElement = document.querySelector('.payments');

                    window.scrollTo({
                        top: paymentsElement.getBoundingClientRect().top + window.scrollY - header.offsetHeight,
                        left: paymentsElement.getBoundingClientRect().left + window.scrollX,
                        behavior: 'smooth',
                    });
                    this.hideLoading();
                    return;
                }
                return this.$store.dispatch('FINISH_ORDER')
                    .then(() => {
                        if (this.$store.getters.hasUserError) {
                            const header = document.querySelector('#header');
                            const erroneousInput = document.querySelector('.is-invalid');
                            const erroneousContainer = erroneousInput.parentNode;

                            window.scrollTo({
                                top: erroneousContainer.getBoundingClientRect().top + window.scrollY - header.offsetHeight,
                                left: erroneousContainer.getBoundingClientRect().left + window.scrollX,
                                behavior: 'smooth',
                            });

                            this.hideLoading();
                            return;
                        }

                        if (this.$store.getters.containsVirtualProduct === false) {
                            const carriersPaymentsMapElement = this.carriersPaymentsMap[this.selectedCarrier];
                            if (!carriersPaymentsMapElement) {
                                alert(this.translations['Invalid carrier/payment combination']);
                                return;
                            }
                            const selectedPayment = carriersPaymentsMapElement.filter(item => {
                                return this.currentPayment.name === item.payment;
                            });
                            if (selectedPayment.length < 1) {
                                alert(this.translations['Invalid carrier/payment combination']);
                            }
                        }
                    });
            },
        }
    }
</script>
<style>
    #cart-cover-spin {
        position:fixed;
        width:100%;
        left:0;
        right:0;
        top:0;
        bottom:0;
        background-color: rgba(255,255,255,0.7);
        z-index:9999;
    }

    @-webkit-keyframes spin {
        from {-webkit-transform:rotate(0deg);}
        to {-webkit-transform:rotate(360deg);}
    }

    @keyframes spin {
        from {transform:rotate(0deg);}
        to {transform:rotate(360deg);}
    }

    #cart-cover-spin::after {
        content:'';
        display:block;
        position:absolute;
        left:48%;top:40%;
        width:40px;height:40px;
        border-style:solid;
        border-color:black;
        border-top-color:transparent;
        border-width: 4px;
        border-radius:50%;
        -webkit-animation: spin .8s linear infinite;
        animation: spin .8s linear infinite;
    }
</style>
